module.exports = __webpack_public_path__ + "static/media/logo-pse.fe1b2abf.png";